
namespace RioERP.Wallet {

    @Serenity.Decorators.registerClass()
    export class CreditJournalDialog extends Serenity.EntityDialog<CreditJournalRow, any> {
        protected getFormKey() { return CreditJournalForm.formKey; }
        protected getIdProperty() { return CreditJournalRow.idProperty; }
        protected getLocalTextPrefix() { return CreditJournalRow.localTextPrefix; }
        protected getNameProperty() { return CreditJournalRow.nameProperty; }
        protected getService() { return CreditJournalService.baseUrl; }
        protected getDeletePermission() { return CreditJournalRow.deletePermission; }
        protected getInsertPermission() { return CreditJournalRow.insertPermission; }
        protected getUpdatePermission() { return CreditJournalRow.updatePermission; }

        protected form = new CreditJournalForm(this.idPrefix);

    }
}